export default {"src":"/_next/static/media/4888c6cef22b13b79f3c035825dc10479f5392f3.62ed0a73.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};